import { Skeleton, Box } from '@bonanza-social/moonlight';
import { memo } from 'react';

function NotificationSkeleton() {
  return (
    <Box gap="space-200">
      <Skeleton height={65} />

      <Box flexDirection="row" justifyContent="space-between">
        <Skeleton width={50} height={28} />
        <Skeleton width={46} height={28} />
      </Box>
      <Box flexDirection="row" justifyContent="space-between">
        <Skeleton width={50} height={28} />
        <Skeleton width={46} height={28} />
      </Box>
      <Box flexDirection="row" justifyContent="space-between">
        <Skeleton width={50} height={28} />
        <Skeleton width={46} height={28} />
      </Box>
    </Box>
  );
}

export default memo(NotificationSkeleton);
